/**
 * SearchArea Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Button from '../../../atoms/buttons/Button';
import TextField from '../../../atoms/forms/TextField';
import { IconSearch } from '../../../atoms/images/Icon';
import { InstantSearchPortal } from '../../global/InstantSearch/portal';
import SearchTermsBox from '../SearchTermsBox';

import tr from '../../../../locales';

interface IOwnProps {
  className?: string;
  data: GQL.IHomePageFeaturedTermsList[];
}

interface IOwnState {
  searchInput: string;
}

const classes = new BEM('search-area');

export default class SearchArea extends React.Component<IOwnProps, IOwnState> {
  constructor(props) {
    super(props);

    this.state = {
      searchInput: '',
    };
  }

  onSearchInput: React.ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    this.setState({ searchInput: target.value });
  }

  onCloseInstantSearch = () => {
    this.setState({ searchInput: '' });
  }

  render() {
    return (
      <div {...classes('', '', this.props.className)}>
        <div {...classes('content-wrapper', '', 'container')}>
          <TextField
            name="search-box"
            placeholder={tr.search.placeholder}
            size="xlarge"
            colorScheme="white"
            inlineButton={(
              <Button
                variant="icon"
                size="xxsmall"
                icon={<IconSearch />}
              />
            )}
            onChange={this.onSearchInput}
            value={this.state.searchInput}
            isControlled
            {...classes('search-box__input')}
          />
          {this.state.searchInput !== '' && (
            <InstantSearchPortal
              initialInput={this.state.searchInput}
              onSearchInput={this.onSearchInput}
              onClose={this.onCloseInstantSearch}
            />
          )}
          <SearchTermsBox data={this.props.data} {...classes('search-terms')} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/SearchArea/index.tsx